export default {
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  PRICE_MAP: Symbol('PRICE_MAP'),
  BASE_PRICE_LIST: Symbol('BASE_PRICE_LIST'),
  SPECIAL_PRICE_LIST: Symbol('SPECIAL_PRICE_LIST'),
  UPDATE_BASE_PRICE: Symbol('UPDATE_BASE_PRICE'),
  UPDATE_SPECIAL_PRICE: Symbol('UPDATE_SPECIAL_PRICE'),
  HOTEL_DISCOUNT_PRICE_LIST: Symbol('HOTEL_DISCOUNT_PRICE_LIST'),
  HOTEL_DISCOUNT_CONFIG: Symbol('HOTEL_DISCOUNT_CONFIG'),
};
